import { render } from "./ListaMateriais.vue?vue&type=template&id=0d6a2792"
import script from "./ListaMateriais.vue?vue&type=script&lang=js"
export * from "./ListaMateriais.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__